import { FlightsFareTypes } from 'constants/flight'
import type { FlightSearchWidgetState } from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateReducer'
import type {
  FlightSearchWidgetFlightItem,
  FlightSearchWidgetInitialFocus,
} from 'contexts/Flights/FlightSearchWidget/types'

interface Options {
  includeDateFields?: boolean
}

function hasValidFlightDate(date: FlightSearchWidgetFlightItem['checkinDate']): boolean {
  return Boolean(date?.isValid())
}

export function getInitialFlightSearchFocus(
  state: FlightSearchWidgetState,
  options: Options = {},
): FlightSearchWidgetInitialFocus | undefined {
  const shouldSelectReturnDate =
    state.fareType?.value === FlightsFareTypes.RETURN

  for (const flight of state.flights) {
    if (!flight.departureAirport?.airportCode) {
      return { field: 'departureAirport', flightId: flight.id }
    }

    if (!flight.arrivalAirport?.airportCode) {
      return { field: 'arrivalAirport', flightId: flight.id }
    }

    if (!options.includeDateFields) {
      continue
    }

    if (!hasValidFlightDate(flight.checkinDate)) {
      return { field: 'departureDate', flightId: flight.id }
    }

    if (shouldSelectReturnDate && !hasValidFlightDate(flight.checkoutDate)) {
      return { field: 'returnDate', flightId: flight.id }
    }
  }

  return undefined
}
